import { createContext } from 'react';

/** Public pages always use the light palette, independently of workspace settings. */
export const PublicThemeContext = createContext(false);
